import { create } from 'zustand';
import { getOsType, Os } from '../utils/agent.ts';
import { getNativeState, NativeState } from '@/native/nativeState.ts';

export type ThemeType = NativeState['Theme'];

const isIOS = () => getOsType() !== Os.ANDROID;

const getInitialTheme = (): ThemeType => {
  const nativeTheme = getNativeState().Theme;
  if (nativeTheme) return nativeTheme;

  const browserTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';

  return isIOS() ? browserTheme : 'light';
};

export const useUserStore = create<{
  userId: string;
  isAgreed: boolean | undefined;
  isAdult: boolean | undefined;
  setUserId: (userId: string) => void;
  setIsAgreed: (isAgreed: boolean) => void;
  setIsAdult: (isAdult: boolean) => void;
}>((set) => ({
  userId: '',
  isAgreed: undefined,
  isAdult: undefined,
  setUserId: (userId: string) => set({ userId: userId }),
  setIsAgreed: (isAgreed: boolean) => set({ isAgreed: isAgreed }),
  setIsAdult: (isAdult: boolean) => set({ isAdult: isAdult }),
}));

interface tokenState {
  token: string | null;
  setToken: (token: string) => void;
}

export const useTokenStore = create<tokenState>((set) => ({
  token: null,
  setToken: (token: string) => set({ token: token }),
}));

export const useThemeStore = create<{
  theme: ThemeType;
  setTheme: (theme: ThemeType) => void;
}>((set) => ({
  theme: getInitialTheme(),
  setTheme: (theme: ThemeType) => set({ theme: theme }),
}));

export function useTheme() {
  return useThemeStore((state) => state.theme);
}
